/**
 * @typedef {string} PaginationCursor
 * @typedef {string} Timestamp
 * @typedef {'collection'|'category'|'app'} DisplayType
 * @typedef {Object} SearchQuery
 *
 * @typedef {{
 *   displayType: DisplayType | SearchQuery,
 *   name: string | SearchQuery,
 *   items: SearchQuery
 * }} TaxonomyFilter
 *
 * @typedef {{
 *   id: string,
 *   type: DisplayType,
 * }} TaxonomySummary
 *
 * @typedef {{
 *   id: string,
 *   name: string,
 *   displayType: DisplayType,
 *   description: string,
 *   bannerImage: string,
 *   items: TaxonomySummary[],
 *   dateCreated: Timestamp,
 *   dateModified: Timestamp,
 * }} TaxonomyItem
 *
 * @typedef {{
 *   data: TaxonomyItem[],
 *   hasNext: boolean,
 *   hasPrevious: boolean,
 *   next: PaginationCursor,
 *   previous: PaginationCursor
 * }} TaxonomySearchResponse
 */

import { path } from 'ramda';
import v3Generic from './v3-generic';
import { urls } from '../config';
import withAxios from '../utils/with-axios';
var _v3Generic = v3Generic('taxonomies'),
  search = _v3Generic.search,
  single = _v3Generic.single;
var bySlug = function bySlug(axios, slug) {
  return axios.get(urls.apiV3("/taxonomies/slug/".concat(slug))).then(path(['data', 'data']));
};
export default {
  /**
   *
   * @param {Object} [optional] $axios
   * @param {import('./v3-generic').MongoSearchOptions} options
   *
   * @returns {Promise<TaxonomySearchResponse>} Unresolved Promise from the API.
   */
  search: search,
  /**
   * Fetch a singular taxonomy by ID
   *
   * @param {Object} [optional] $axios Axios instance.
   * @param {String} id
   *
   * @returns {Promise<TaxonomyItem>} Unresolved Promise from the API.
   */
  single: single,
  /**
   * Fetch a singular taxonomy by slug
   *
   * @param {Object} [optional] $axios Axios instance.
   * @param {String} slug
   *
   * @returns {Promise<TaxonomyItem>} Unresolved Promise from the API.
   */
  bySlug: withAxios(bySlug)
};